import React, { useRef, useEffect } from 'react';

function DashboardManualJaJP() {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const handleLoad = () => {
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.document.body.style =
          'margin: auto; -moz-transform: scale(2); zoom: 2;';
      }
    };

    iframe.contentWindow.addEventListener('load', handleLoad);

    return () => {
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.removeEventListener('load', handleLoad);
      }
    };
  }, []);

  return (
    <iframe
      title="Dashboard Manual"
      src={`${
        import.meta.env.VITE_PUBLIC_URL
      }static/manual/DoCloud_1.0.0.7/DoCloud™操作マニュアル 7daaf275768f4244b2feec03d563be66.html`}
      ref={iframeRef}
      width="100%"
      height="100%"
      frameBorder={0}
    />
  );
}

export default DashboardManualJaJP;
